export default __webpack_public_path__ + "static/media/shield5.956bc24c.png";